var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.998 12.467-4.8-4.8V3.2h4.468l4.8 4.8zm5.035-5.032L7.998 2.4h-5.6V8l5.035 5.035.565.565.565-.565 4.47-4.47.565-.565zM5.198 5.8a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2"
  })));
};
export default SvgTag;